import React, { Component } from 'react';
import withContexts from 'helpers/contextsMerge'
import Breadcrumbs from 'components/elements/Breadcrumbs.js'
import breadcrumbsConst from 'constants/breadcrumbs.js'

class PageBreadcrumbs extends Component {
    constructor(props) {
        super(props);
        this.state = { brElem: null, dict: props.dict };
    }

    static getDerivedStateFromProps(props, state) {
        if (props.pathcontext.currentPath !== state.brElem) {
            if (props.pathcontext.currentPath === '/users' && props.user.role && props.user.role.code !== 'admin') {
                return {
                    brElem: breadcrumbsConst.filter(br => br.path.startsWith('/users-account'))[0]
                };
            }
            return {
                brElem: breadcrumbsConst.filter(br => br.path.startsWith(props.pathcontext.currentPath))[0]
            };
        }

        return null;
    }

    componentDidMount() {
        const { setBreadCrumbs } = this.props;
        const { brElem } = this.state;

        if (brElem) setBreadCrumbs(brElem.list)
    }

    componentDidUpdate(prevProps, prevState) {
        const { setBreadCrumbs, langContext: {
            currentLang
        }, pathcontext: { query } } = this.props;
        const { brElem } = this.state;

        if (brElem &&
            (brElem !== prevState.brElem
                || currentLang !== prevProps.langContext.currentLang
                || query !== prevProps.pathcontext.query)) {
            setBreadCrumbs(brElem.list);
        }
    }

    componentWillUnmount() {
        const { resetBreadCrumbs } = this.props;
        resetBreadCrumbs();
    }

    render() {
        const { breadCrumbs, dict } = this.props;

        return (
            <Breadcrumbs
                breadCrumbsList={breadCrumbs}
                dict={dict}
            />
        );
    }
}

export default withContexts(PageBreadcrumbs);
